import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-contact-log',
  templateUrl: './contact-log.component.html',
  styleUrls: ['./contact-log.component.less']
})
export class ContactLogComponent implements OnInit {
@Input() roomId=''
  @Input() isHandset = false;
  logsList:any[]=[];
  isLoading: boolean;
  constructor(private api:ApiService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.api.getDesignEmailLog(this.roomId).subscribe((res:any)=>{
      
      this.logsList = res;
      this.isLoading = false;
    })
  }

}
